/**
 * Maps review highlight text from database to i18n translation keys
 */
export const getHighlightTranslationKey = (highlight: string): string => {
  const highlightKeyMap: Record<string, string> = {
    'Delivered as promised': 'deliveredAsPromised',
    'Same price as U.S. stores': 'samePriceAsUS',
    'Easy ordering process': 'easyOrdering',
    'Helpful support': 'helpfulSupport',
    'Secure & careful packaging': 'securePackaging',
  };
  
  return highlightKeyMap[highlight] || highlight;
};
